import React from 'react';
import { BadgeCheckIcon, DatabaseIcon, MegaphoneIcon, WorkflowIcon } from 'lucide-react';
import { Button } from './Button';
import { benefits } from '../data/content';
import type { LandingActions } from '../types/actions';
const iconMap = {
  brand: BadgeCheckIcon,
  automation: WorkflowIcon,
  marketing: MegaphoneIcon,
  operations: DatabaseIcon
};
export function BenefitsSection({
  onFormCta
}: Pick<LandingActions, 'onFormCta'>) {
  return <section id="growth-stack" className="w-full border-y border-line bg-canvas" data-id="element-8" data-mp="38qpi5odbdeks">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-9" data-mp="3dsomb0gvofis">
        <div className="max-w-2xl" data-id="element-10" data-mp="2zs4528qm2rre">
          <h2 className="font-display text-[26px] font-semibold leading-[1.12] tracking-[-0.025em] text-ink md:text-[38px]" data-id="element-11" data-mp="2zt6qw292u40g">
            The systems behind a more consistent real estate business.
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-ink-600 md:text-[17px]" data-id="element-12" data-mp="xxwddli5qmyr">
            You stay focused on relationships, clients, and your local market. NEXT helps build and operate the systems
            that support consistent growth.
          </p>
        </div>

        <div className="mt-9 grid gap-4 md:mt-12 md:grid-cols-3" data-id="element-13" data-mp="27d2inz5r8bff">
          {benefits.map(card => {
          const Icon = iconMap[card.icon];
          if (card.featured) {
            return <article key={card.title} className="rounded-2xl bg-ink p-6 text-white md:col-span-3 md:grid md:grid-cols-[0.9fr_1.1fr] md:items-center md:gap-10 md:p-9" data-id="element-14" data-mp="2g6nw9f66nmn9">
                  <div data-id="element-15" data-mp="22ehks6dz63u5">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10" data-id="element-16" data-mp="22erartz0sazu">
                      <Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-17" data-mp="1xf4utcrt4gnc" />
                    </span>
                    <h3 className="mt-5 font-display text-[24px] font-semibold leading-tight tracking-[-0.025em] md:mt-6 md:text-[32px]" data-id="element-18" data-mp="3dsld784wzjx3">
                      {card.title}
                    </h3>
                  </div>
                  <p className="mt-3 text-[15px] leading-relaxed text-white/75 md:mt-0 md:text-[17px]" data-id="element-19" data-mp="3gupqizfh6tvk">{card.body}</p>
                </article>;
          }
          return <article key={card.title} className="flex h-full flex-col rounded-2xl border border-line bg-white p-6" data-id="element-20" data-mp="3pwgxe7lr56r0">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-soft" data-id="element-21" data-mp="3usxx7z2bd9jx">
                  <Icon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-22" data-mp="2x57285qn3ps2" />
                </span>
                <h3 className="mt-5 font-display text-[19px] font-semibold leading-snug tracking-[-0.02em] text-ink" data-id="element-23" data-mp="324a8tum9q425">
                  {card.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-600" data-id="element-24" data-mp="3bwy1qea4nnvl">{card.body}</p>
              </article>;
        })}
        </div>

        <div className="mt-9 md:mt-12" data-id="element-25" data-mp="2jflphd3fo6sh">
          <Button onClick={() => onFormCta('benefits')} fullWidth className="sm:w-auto" data-id="element-26" data-mp="2jekcv46rrc8n">
            Explore the NEXT Agent Platform
          </Button>
        </div>
      </div>
    </section>;
}